import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.main-page__swiper', {
        direction: 'vertical',
        centeredSlides: false,
        slidesPerView: 1,
        loop: true,
        speed: 500,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        autoplay: {
            delay: 7500,
        },
        breakpoints: {
            100: {
                direction: 'horizontal',
            },
            1024: {
                slidesPerView: 1,
            },
            10000: {
                slidesPerView: 1,
            },
        },
    });

    const helpButtons = document.getElementsByClassName('banner-help');

    for (const button of helpButtons) {
        button.addEventListener('mouseenter', () => {
            swiper.autoplay.stop();
        });

        button.addEventListener('mouseleave', () => {
            swiper.autoplay.start();
        });
    }

    const swiper1 = new Swiper('.harvest-wrapper', {
        direction: 'horizontal',
        centeredSlides: false,
        slidesPerView: 4,
        spaceBetween: 14,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
        },
        breakpoints: {
            100: {
                slidesPerView: 1.3,
                spaceBetween: 20,
                loop: true,
                centeredSlides: false,
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 20,
                centeredSlides: true,

            },
            780: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1140: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
            10000: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
        },
    });


    const swiper2 = new Swiper('.report-wrapper__slider', {
        direction: 'horizontal',
        centeredSlides: false,
        slidesPerView: 4,
        spaceBetween: 32,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next1",
            prevEl: ".swiper-button-prev1",
        },
        scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
        },
        breakpoints: {
            100: {
                slidesPerView: 1.3,
                spaceBetween: 20,
                loop: true,
                centeredSlides: false,
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 20,
                centeredSlides: true,

            },
            780: {
                slidesPerView: 2,
                spaceBetween: 32,
            },
            1140: {
                slidesPerView: 4,
                spaceBetween: 32,
            },
            10000: {
                slidesPerView: 4,
                spaceBetween: 32,
            },
        },
    });
    const swiper3 = new Swiper('.news-slider', {
        direction: 'horizontal',
        centeredSlides: false,
        slidesPerView: 3,
        spaceBetween: 32,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next2",
            prevEl: ".swiper-button-prev2",
        },
        breakpoints: {
            100: {
                slidesPerView: 1.3,
                spaceBetween: 20,
                loop: true,
                centeredSlides: false,
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 20,
                centeredSlides: true,

            },
            780: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1140: {
                slidesPerView: 3,
                spaceBetween: 32,
            },
            10000: {
                slidesPerView: 3,
                spaceBetween: 23,
            },
        },
    });

    const swiper4 = new Swiper('.our-teams__slider', {
        direction: 'horizontal',
        centeredSlides: false,
        slidesPerView: 5,
        spaceBetween: 15,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next3",
            prevEl: ".swiper-button-prev3",
        },
        scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
        },
        breakpoints: {
            100: {
                slidesPerView: 1.5,
                spaceBetween: 12,
                loop: true,
                centeredSlides: false,
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 12,
                centeredSlides: true,

            },
            780: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1140: {
                slidesPerView: 5,
                spaceBetween: 20,
            },
            10000: {
                slidesPerView: 5,
                spaceBetween: 20,
            },
        },
    });

    const swiper5 = new Swiper('.reports-single__img-slider', {
        direction: 'horizontal',
        centeredSlides: false,
        slidesPerView: 3,
        spaceBetween: 32,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next4",
            prevEl: ".swiper-button-prev4",
        },
        breakpoints: {
            100: {
                slidesPerView: 1.5,
                spaceBetween: 12,
                loop: true,
                centeredSlides: false,
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 12,
                centeredSlides: true,

            },
            780: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1140: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            10000: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        },

    });
    
});

